module.exports = __webpack_public_path__ + "img/adM.8bb29a6f.svg";